import { components } from "@certn/api/generated-schemas/client-portal";
import { formatDate } from "@certn/utils";

function findLatestProfileCase(
  data: readonly components["schemas"]["CaseForPersonListView"][],
  latestModified: string
) {
  const latestCase = data.find((item) => item.modified === latestModified);

  return {
    email: latestCase?.case_report_applicant_info_email,
    name:
      latestCase?.case_report_applicant_info_given_name +
      " " +
      latestCase?.case_report_applicant_info_family_name,
  };
}

function getAllTags(
  data: readonly components["schemas"]["CaseForPersonListView"][]
) {
  let allTags: string[] = [];
  data.map((item) => {
    allTags = allTags.concat(item.tags);
  });
  return [...new Set(allTags)];
}

export function mapProfileResultsToRows(
  data: components["schemas"]["PersonList"][] | undefined
) {
  if (!data) {
    return [];
  }

  return data?.map((person) => ({
    id: person.id,
    latest_case_modified: formatDate(
      person.latest_case_modified,
      "MMM dd, yyyy"
    ),
    ...findLatestProfileCase(person.case_set, person.latest_case_modified),
    tags: getAllTags(person.case_set),
    groups: [
      ...new Set(
        person.case_set.map((single_case) => single_case.customer_group_name)
      ),
    ].join(", "),
  }));
}
